import { EXPORT_DOCUMENT_TITLE_KEYS } from './exportExcelNaming';
import { uiT } from './uiTranslate';

/** Visible leading order for calb008/calb032: checkbox → edit icon → ID. */
export const CALIBRATION_COMPANY_LEADING_COLUMN_FIELDS = Object.freeze(['rowSelection', 'editor', 'id']);

/**
 * Saved user/standard masks may still store checkbox → ID → editor.
 * Reorder only those three fields when present; leave remaining columns intact.
 */
export function pinCalibrationCompanyLeadingColumns(attributes) {
  if (!Array.isArray(attributes) || attributes.length === 0) return attributes;
  const leadingSet = new Set(CALIBRATION_COMPANY_LEADING_COLUMN_FIELDS);
  const byField = new Map();
  const rest = [];
  for (const node of attributes) {
    const field = node && typeof node === 'object' ? node.field : null;
    if (typeof field === 'string' && leadingSet.has(field) && !byField.has(field)) {
      byField.set(field, node);
    } else {
      rest.push(node);
    }
  }
  const leading = CALIBRATION_COMPANY_LEADING_COLUMN_FIELDS
    .map((field) => byField.get(field))
    .filter(Boolean);
  if (leading.length === 0) return attributes;
  return [...leading, ...rest];
}

export const CALIBRATION_COMPANY_LIST_MASKS = Object.freeze({
  /** calb008 Karty firiem → calb009 Karta kalibračnej firmy */
  certificates: Object.freeze({
    pageListKey: 'CalibrationCompanyCertificateList',
    detailPage: 'CalibrationCompanyCertificateAdd',
    detailMask: 'calb009',
    editTabKey: 'CalibrationCompanyList.Tab.CompanyCard',
    get editTabName() { return uiT('CalibrationCompanyList.Tab.CompanyCard'); },
    get favoriteTitle() { return uiT('CalibrationCompanyList.Favorite.Certificates'); },
    notificationPage: 'CalibrationCompanyCertificateList',
    exportTitleKey: EXPORT_DOCUMENT_TITLE_KEYS.CALIBRATION_COMPANIES,
  }),
  /** calb032 Certifikáty firiem → calb033 Certifikáty kalibračnej firmy */
  cards: Object.freeze({
    pageListKey: 'CalibrationCompanyCardList',
    detailPage: 'CalibrationCompanyCardDetail',
    detailMask: 'calb033',
    editTabKey: 'CalibrationCompanyList.Tab.CompanyCerts',
    get editTabName() { return uiT('CalibrationCompanyList.Tab.CompanyCerts'); },
    get favoriteTitle() { return uiT('CalibrationCompanyList.Favorite.Cards'); },
    notificationPage: 'CalibrationCompanyCardList',
    exportTitleKey: EXPORT_DOCUMENT_TITLE_KEYS.CALIBRATION_COMPANIES,
  }),
});
